import Vue from 'vue';
import {beepSound, speech} from '@/common/utils';
import moment from "moment";
import {phone, name} from '@/common/masking'
Vue.mixin({
  data() {
    return {
      modal: this.$bvModal,
      bvToast: this.$bvToast,
      regExps: {
        hex  : /^[0-9a-fA-F]+$/,
        pwd  : /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/, // 비밀번호 최소8자 영문,숫자,특수문자 조합
        hp   : /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/, // 휴대전화번호
        ip   : /(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}/, // 아이피주소
        cidr : /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/([0-9]|[1-2][0-9]|3[0-2])$/, // CIDR ex)"0.0.0.0/0"
        num  : /^[0-9]+$/, // 숫자검사
        tel  : /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]))-(\d{3,4})-(\d{4})$/, // 일반 전화번호
        url  : /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
        sUrl : /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
        nan  : /[^0-9]/g,
        base64: /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/
      }

    }
  },
  methods: {
    /**
     * 패킷 수신 표시색(탱크 카드 테두리·헤더 배지)을 현재 모드에 맞춘다.
     * 다크 모드는 종전 값(dark 대기 / info 수신)을 그대로 쓰고, 라이트 모드에서는
     * 흰 배경에서 dark→info 변화가 잘 안 보여 대기 secondary / 수신 primary 로 바꾼다.
     * 경보(warning)·오류(danger)는 두 모드 모두 그대로다.
     */
    /**
     * 탱크 카드(및 그 칼럼)의 폭. 헤더의 큰 글씨 모드(largeFont)면 글자가 커져 내용이 넘치므로
     * 폭도 같은 비율(1.24배)로 키운다.
     */
    tankCardStyle(minW, maxW){
      const k = this.$store?.state?.largeFont ? 1.24 : 1;
      return { minWidth: `${Math.round(minW * k)}px`, maxWidth: `${Math.round(maxW * k)}px` };
    },

    signalVariant(sig){
      if( this.$store?.state?.darkMode ) return sig;
      if( sig === 'dark' ) return 'secondary';
      if( sig === 'info' ) return 'primary';
      return sig;
    },
    makeRandom(min, max){
      return Math.floor(Math.random()*(max-min+1)) + min;
    },

    async getDownload(fileName, result){
      try{
        let blob;
        const fileLink = document.createElement('a')
        let ext = fileName.split('.').pop();
        if(ext==='xlsx'){
          blob = new Blob([result.data], {
            type: result.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
        }else {
          blob = new Blob([result.data])
        }

        fileLink.href = window.URL.createObjectURL(blob)
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
      }catch(err){
        console.error('getDownload---err--->', err);
      }
    },
    async alertTest() {
      let r = null;
      try{

        await beepSound('danger');

        await this.modal.msgBoxOk( '메시지', {
          title: '[TEST] Warning' ,
          headerBgVariant: 'warning',
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          okVariant: 'warning',
          centered: true, size: 'sm'
        });
        return r;
      }catch(err){
        console.error("# alertWarn Error ---> ",err);
      }
    },
    async alertModal(msg, title='Information', variant='info'){
      try{
        await beepSound('success');
        await this.modal.msgBoxOk( msg, {
          title: title,
          buttonSize: 'sm',
          headerBgVariant: variant,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          okVariant: 'primary',
          centered: true, size: 'sm'
        });
      }catch(err){
        console.error("# alertAsync Error ---> ",err);
      }
    },
    async alertInfo(msg, title='Information', variant='info'){
      try{
        await beepSound('success');
        await this.modal.msgBoxOk( msg, {
          title: title,
          buttonSize: 'sm',
          headerBgVariant: variant,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          okVariant: 'primary',
          centered: true, size: 'sm'
        });
      }catch(err){
        console.error("# alertAsync Error ---> ",err);
      }
    },
    async alertWarn(msg, title=null){
      let r = null;
      try{
        await beepSound('warning');
        r = await this.modal.msgBoxOk( msg, {
          title: title? title:'[알림] Warning' ,
          headerBgVariant: 'warning',
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          okVariant: 'warning',
          centered: true, size: 'sm'
        });
        return r;
      }catch(err){
        console.error("# alertWarn Error ---> ",err);
      }
    },
   async alertDanger(msg, code=999){
      let r = null;
      try{
        await beepSound('danger');

        r = await this.modal.msgBoxOk( msg, {
          title: `[${code}] Error ` ,
          headerBgVariant: 'danger',
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          okVariant: 'danger',
          centered: true,
          size: 'sm'
        });
        return r;
      }catch(err){
        console.error("# alertDanger Error ---> ",err);
      }
    },
    async alertError(err){
      try{
        // console.log(err);
        return await this.alertDanger(err.message, err.status?err.status:'E999');
      }catch(err){
        console.error("# alertError ---> ",err);
      }
    },

    async alertSuccess(msg, title=null){
      let r = null;
      try{
        await beepSound('success');
        r = await this.modal.msgBoxOk( msg, {
          title: (title)? title:'[알림] 완료' ,
          headerBgVariant: 'success',
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          okVariant: 'info',
          centered: true,
          size: 'sm'
        });
        return r;
      }catch(err){
        console.error("# alertSuccess Error ---> ",err);
      }
    },

    async confirmModal (msg, title=null){
      let r = null;
      try{
        await beepSound('danger');
        r = await this.modal.msgBoxConfirm( msg, {
          title: (!title)?'[확인] Confirm':title,
          buttonSize: 'sm',
          headerBgVariant: 'warning',
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          okVariant: 'danger',
          centered: true, size: 'sm'
        });
        return r;
      }catch(err){
        console.error("# confirmModal Error ---> ",err);
      }
    },
    async toastInfo(msg, title='INFORMATION', type='info', beep=true){
      try{
        this.bvToast.toast( msg, {
          title: title,
          variant: type,
          autoHideDelay: 2000,
          appendToast: true
        });

        if(beep) await beepSound(type);

      }catch(err){
        console.error(err);
      }
    },
    toastWarn(msg){
        this.bvToast.toast( msg, {
          title: 'WARNING',
          variant: 'warning',
          autoHideDelay: 2000,
          appendToast: true
        });
        beepSound('warning' );
    },
    toastAlarm(title, msg, variant='danger'){
      this.bvToast.toast( msg, {
        title: title,
        variant: variant,
        toaster: 'b-toaster-bottom-center',
        // toaster: 'b-toaster-bottom-full',
        autoHideDelay: 5000,
        appendToast: true
      });
    },
    toastEvent(title, msg, variant='danger', secs=5){
      this.bvToast.toast( msg, {
        title: title,
        variant: variant,
        toaster: 'b-toaster-bottom-center',
        // toaster: 'b-toaster-bottom-full',
        autoHideDelay: secs * 1000,
        appendToast: true
      });
    },


    async toastResult(result, message='요청', tts=true){
      try{
        let type = 'warning';
        let title = `${message} 결과`;
        let mesg, speechMsg;
        if(!result){
          type = 'danger';
          mesg = `[${message} 에러] 응답 없음`;
        }else if(result.code===200){
          type = 'primary';
          mesg = `[${message} 성공] ${result.message}`;
          speechMsg = `${message} 완료`;
        }else{
          mesg = `[${message} 실패] ${result.message}`;
          speechMsg = `${message} 실패! 메시지를 확인하시기 바랍니다.`;
        }

        beepSound(type);
        this.bvToast.toast( mesg, {
          title: title,
          variant: type,
          autoHideDelay: 2000,
          appendToast: true
        })
        // console.log( 'tts---', tts)

        if(tts===true) speech(speechMsg);


      }catch(err){
        console.error(err);
      }
    },
    toastError(err){
      this.bvToast.toast(
        err.message,
        {
          title: 'ERROR',
          variant: 'danger',
          autoHideDelay: 3000,
          appendToast: true,
          toaster: 'b-toaster-top-left',
        })
    },
    toDateFromStr(v){
      return v.slice(0,8).replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
    },

    toHoursAndMinutes(totalMinutes) {
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${hours}:${minutes > 0 ? `${minutes}` : ''}`;
    },

    /**
     * 경과 시간(분)을 사람이 읽는 문자열로 바꾼다.
     *
     * 음수는 0 으로 본다. 패킷 시각이 브라우저 시각보다 조금이라도 앞서면
     * (장비 RTC 오차, 서버-클라이언트 시각차) 입력이 음수가 되는데,
     * 종전에는 Math.floor(-0.0000019) 가 -1 이 되어 '-1 년' 으로 표시됐다.
     * 미래 시각은 사실상 방금이므로 최소 단위로 떨어뜨린다.
     *
     * @param temp {Number} 경과 시간(분)
     * @returns {String}
     */
    toHumanTime(temp=0){
      const mins = Number(temp);
      temp = (Number.isFinite(mins) && mins > 0 ? mins : 0) * 60;

      let years = Math.floor(temp / 31536000);
      if (years) {
        return years + ' 년';
      }
      //TODO: Months! Maybe weeks?
      let days = Math.floor((temp %= 31536000) / 86400);
      if (days) {
        return days + ' 일';
      }
      let hours = Math.floor((temp %= 86400) / 3600);
      if (hours) {
        return hours + ' 시간';
      }
      let minutes = Math.floor((temp %= 3600) / 60);
      if (minutes) {
        return minutes + ' 분';
      }
      let seconds = Math.floor(temp % 60);
      if (seconds) {
        return seconds + ' 초';
      }
      return '1초 미만'; //'just now' //or other string you like;
    },
    toHumanSize(bytes, si=true){
      let thresh = si ? 1000 : 1024;
      if(Math.abs(bytes) < thresh) {
        return bytes + ' B';
      }
      let units = si
        ? ['kB','MB','GB','TB','PB','EB','ZB','YB']
        : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
      let u = -1;
      do {
        bytes /= thresh;
        ++u;
      } while(Math.abs(bytes) >= thresh && u < units.length - 1);
      return bytes.toFixed(1)+' '+units[u];
    },
    /**
     * YYYYMMDDHHmmss --> HH:mm:ss
      * @param v
     * @returns {*|string}
     */
    toTimeStr(v){
      return v? v.slice(-6).match(/\d{2}/g).join(":"):'';
    },
    toLocalTime(v){
      // console.log(val);
      return v?moment(v).format("YYYY-MM-DD HH:mm"):''
    },
    toLocalYmd(v){
      // console.log(val);
      return v?moment(v).format("YYYY-MM-DD"):''
    },
    toShortTime(v){
      // console.log(val);
      return v?moment(v).format("M/DD HH:mm"):''
    },
    toOnlyTime(v){
      // console.log(val);
      return v?moment(v).format("HH:mm:ss"):''
    },
    toLocalTimeSec(v){
      // console.log(val);
      return v?moment(v).format("YYYY-MM-DD HH:mm:ss"):''
    },
    toIsoDate(v){
      return v? moment(v, 'YYYY-MM-DD HH:mm').toISOString(): ''
    },
    isoToYmd(v){
      return v? moment(v).format('YYYY-MM-DD'): ''
    },
    /**
     * v='243' -> 02:43
     * */
    toHHmm(v){
      if(v){
        let str = v.replace(this.regExps.nan, '');
        let val = ('0000'+str).slice(-4).match(/\d{2}/g).join(":")
          if(/^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(val)) return val
        else return '00:00';

      }else{
        return '00:00';
      }

    },
    ymdToIso(v){
      // console.log( 'ymdToIso()--->', v );
      return v? moment(v, 'YYYY-MM-DD').toISOString(): ''
    },
    toPhoneTxt(v){
      return v? v.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`):''
    },
    toPhoneMask(v){
      return phone(this.toPhoneTxt(v))
    },
    toNameMask(v){
      return v? name(v):''
    },
    toPhoneVal(v){
      return v? v.replace(/[^0-9]/g, ''):''
    },
    toComma(n){
      if(!n) return 0;
      let reg = /(^[+-]?\d+)(\d{3})/;   // 정규식
      n += '';                          // 숫자를 문자열로 변환
      while (reg.test(n)) {
        n = n.replace(reg, '$1' + ',' + '$2');
      }
      return n;
    },
    toCommaInt(n){
      if(!n) return 0;
      return this.toComma(n.toFixed(0));
    },
    toCommaFix2(n){
      if(!n) return 0;
      return this.toComma(n.toFixed(2));
    },
    isValidExp(val, exp, len=0) {
      let ret = true;
      if(len && val.length !== len) {
        ret = false;
      }
      return this.regExps[exp].test(val) && ret;
    },
    checkDigit(value, len) {
      // ^: 시작, \d: 숫자, {n}: n번 반복, $: 끝
      const regex = new RegExp(`^\\d{${len}}$`);
      return regex.test(value);
    },
    getCodeMaps(group){
      // console.log(this.$store.state.codeMaps[group]);
      return this.$store.state.codeMaps[group]?this.$store.state.codeMaps[group]:{};
    },
    getCodeOpts(group){
      // console.log(this.$store.state.codeOpts[group]);
      return this.$store.state.codeOpts[group]?this.$store.state.codeOpts[group]:[];
    },

  }
})
